import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable()
export class SubscriptionService {

    constructor(
        @Inject( 'ENV' ) private env: any,
        private http: HttpClient,
    ) { }


    fetchSubscriptions () {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/ticket-subscription/channel/web/list`;
        return this.http.get( url ).pipe(
            map( ( s: any[] ) => {
                return s.map( subsctiption => {
                    if ( subsctiption.card_id.indexOf( '-' ) !== -1 ) {
                        subsctiption.card_id = subsctiption.card_id.split( '-' )[ 1 ];
                    }
                    return subsctiption;
                } );
            } )
        );
    }

    deleteSubscription ( subscription ) {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/ticket-subscription/channel/web/id/${subscription.id}`;
        return this.http.delete( url );
    }
}
